import React from "react";
import { Link } from "react-router-dom";
import { URLS } from "../_config";

const LeftMenu: React.FC = () => {
  return (
    <div className="vertical-menu">
      <div data-simplebar className="h-100">
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title" key="t-menu">
              Account
            </li>

            <li>
              <Link to={URLS.PROFILE} className="waves-effect">
                <i className="profile-icon"></i>
                <span key="t-dashboards">Personal Dashboard</span>
              </Link>
            </li>
            <li>
              <Link to={URLS.MYLOS} className="waves-effect">
                <i className="los-icon"></i>
                <span key="t-dashboards">My Account</span>
              </Link>
            </li>

            <li>
              <Link to={URLS.FUNDING.REQUEST_LIST} className="waves-effect">
                <i className="scenario-icon"></i>
                <span key="t-dashboards">Loan Request</span>
              </Link>
            </li>
            <li>
              <Link to={URLS.ESCALATION.LIST} className="waves-effect">
                <i className="request-icon"></i>
                <span key="t-dashboards">Request Resolution</span>
              </Link>
            </li>
            <li>
              <a href="javascript: void(0);" className="waves-effect">
                <i className="subscriptions-icon"></i>
                <span key="t-dashboards">My Purchase</span>
              </a>
            </li>

            <li>
              <Link to={URLS.PREORDER.LIST} className="waves-effect">
                <i className="orders-icon"></i>
                <span key="t-dashboards">PRE Orders</span>
              </Link>
            </li>

            <li>
              <Link to={URLS.SHOP} className="waves-effect">
                <i className="marketplace-icon"></i>
                <span key="t-dashboards">Shop</span>
              </Link>
            </li>

            <li>
              <Link to={URLS.FUNDINGOVERVIEW.LIST} className="waves-effect">
                <i className="marketplace-icon"></i>
                <span key="t-dashboards">Loan Tracking</span>
              </Link>
            </li>

            <li className="menu-title" key="t-menu">
              Directories
            </li>

            <li>
              {/* <Link to={URLS.SCENARIO_COACHES} className="waves-effect">
                                <i className="coaches-icon"></i>
                                <span key="t-dashboards">Scenario Coaches / Recommendations </span>
                            </Link> */}
              <Link to={URLS.SCENARIO_COACHES} className="waves-effect">
                <i className="coach-icon"></i>
                <span key="t-dashboards">Recommended Coaches</span>
              </Link>
            </li>
            <li>
              <Link to={URLS.LENDER} className="waves-effect">
                <i className="financier-icon"></i>
                <span key="t-dashboards">Lender</span>
              </Link>
            </li>
            <li>
              <Link to={URLS.PROCESSORS} className="waves-effect">
                <i className="processors-icon"></i>
                <span key="t-dashboards">Processor</span>
              </Link>
            </li>
            <li>
              <Link to={URLS.VENDORS} className="waves-effect">
                <i className="vendors-icon"></i>
                <span key="t-dashboards">Vendor</span>
              </Link>
            </li>
            <li className="menu-title" key="t-menu">
              Agencies
            </li>
            <li>
              <a href="javascript: void(0);" className="waves-effect">
                <i className="nav-user-icon"></i>
                <span key="t-dashboards">Users</span>
              </a>
            </li>
            <li>
              <a href="javascript: void(0);" className="waves-effect">
                <i className="ticket-icon"></i>
                <span key="t-dashboards">Tickets</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default LeftMenu;
